// NPM Imports
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
import Description from '../../ui-helper-elements/Description'
// JS Imports
//@ts-ignore
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

interface HoverDifferenceDescriptionProps {
   children?: React.ReactNode
   previousPlan: string
   previousQuantity: number
   previousInvoicedAmount: number
   previousStartDate: string
   previousCurrencyObject: any
   placement?: string
}

export default function HoverDifferenceDescription({
   children,
   previousPlan,
   previousQuantity,
   previousInvoicedAmount,
   previousStartDate,
   previousCurrencyObject,
   placement = 'top',
}: HoverDifferenceDescriptionProps) {
   const state = useQuoteContext()
   const { getString } = state

   const content = (
      <>
         <div className='row text-nowrap'>
            <p className='col'>{previousPlan}</p>
         </div>
         <div className='row text-nowrap'>
            <p className='col'>{getString('global.Quantity')}</p>
            <p className='col text-end'>{previousQuantity}</p>
         </div>
         <div className='row text-nowrap'>
            <p className='col'>
               {getString('product.HoverDifferenceDescription.InvoicedAmount')}
            </p>
            <p className='col text-end'>
               {formatFloatAsCurrencySymbol(
                  previousInvoicedAmount,
                  previousCurrencyObject,
               )}
            </p>
         </div>
         <div className='row text-nowrap'>
            <p className='col'>
               {getString('product.HoverDifferenceDescription.StartDate')}
            </p>
            <p className='col text-end'>{previousStartDate}</p>
         </div>
      </>
   )

   return (
      <Description
         title={getString('global.PreviousPlan')}
         className='col col-bhr-blue'
         content={content}
         placement={placement}
      >
         {children}
      </Description>
   )
}
